// @flow

export type DataProvidesProps = {|
  'data-provides'?: string,
  'data-provides-of'?: string,
  'data-provides-for'?: string,
|};

export const getDataProvidesProps = (props: any) => {
  const dataProvidesProps = {};
  if (props['data-provides']) {
    dataProvidesProps['data-provides'] = props['data-provides'];
  }
  if (props['data-provides-of']) {
    dataProvidesProps['data-provides-of'] = props['data-provides-of'];
  }
  if (props['data-provides-for']) {
    dataProvidesProps['data-provides-for'] = props['data-provides-for'];
  }
  return dataProvidesProps;
};
